// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_wrapper":"breadCrumb_breadcrumb_wrapper__2-Mo0"};